module.exports = __webpack_public_path__ + "static/media/data_storage.0f9c6aee.jpg";